/**
 * Modulo para las campos extra
 */
import angular from 'angular';
import CampoExtraService from "./camposExtraService";
import FirmaControlador from "../componentes/firma-componente/firmaControlador";
import FirmaComponente from "../componentes/firma-componente/firmaComponente";
import CamposExtraDetallesCtrl from "./campos-extra-detalles/camposExtraDetallesCtrl";
import CamposExtraBooleanCtrl from "./campos-extra-tipos/boolean/camposExtraBooleanCtrl";
import CamposExtraDetallesDirectiva from "./campos-extra-detalles/camposExtraDetallesDirectiva";
import CampoExtraBooleanDirectiva from "./campos-extra-tipos/boolean/camposExtraBooleanDirectiva";
import CamposExtraDateCtrl from "./campos-extra-tipos/date/camposExtraDateCtrl";
import CampoExtraDateDirectiva from "./campos-extra-tipos/date/camposExtraDateDirectiva";
import CamposExtraNumberCtrl from "./campos-extra-tipos/number/camposExtraNumberCtrl";
import CampoExtraNumberDirectiva from "./campos-extra-tipos/number/camposExtraNumberDirectiva";
import CamposExtraTextCtrl from "./campos-extra-tipos/text/camposExtraTextCtrl";
import CampoExtraTextDirectiva from "./campos-extra-tipos/text/camposExtraTextDirectiva";
import CamposExtraListCtrl from "./campos-extra-tipos/value-list/camposExtraListCtrl";
import campoExtraListDirectiva from "./campos-extra-tipos/value-list/camposExtraListDirectiva";
import CamposExtraListApiCtrl from "./campos-extra-tipos/value-list-api/camposExtraListApiCtrl";
import campoExtraListApiDirectiva from "./campos-extra-tipos/value-list-api/camposExtraListApiDirectiva";
import DialogAutocompleteCtrl from "./campos-extra-tipos/value-list-api/dialog-autocomplete/dialog-autocomplete.controller";
import CamposExtraFirmaCtrl from "./campos-extra-tipos/firma/camposExtraFirmaCtrl";
import CamposExtraFirmaDirectiva from "./campos-extra-tipos/firma/camposExtraFirmaDirectiva";
import ngResourceModuleName from 'angular-resource';
import ngSanitize from 'angular-resource';


const CamposExtraModule = angular
    .module('camposExtra', [ngResourceModuleName, ngSanitize])
    .service('CampoExtra', CampoExtraService)
    .controller('FirmaControlador', FirmaControlador)
    .component('firmaComponente', FirmaComponente())
    .controller('DialogAutocompleteCtrl', DialogAutocompleteCtrl)
    .controller('CamposExtraDetallesCtrl', CamposExtraDetallesCtrl)
    .directive('camposExtra', CamposExtraDetallesDirectiva)
    .controller('CamposExtraBooleanCtrl', CamposExtraBooleanCtrl)
    .directive('campoExtraBoolean', CampoExtraBooleanDirectiva)
    .controller('CamposExtraDateCtrl', CamposExtraDateCtrl)
    .directive('campoExtraDate', CampoExtraDateDirectiva)
    .controller('CamposExtraNumberCtrl', CamposExtraNumberCtrl)
    .directive('campoExtraNumber', CampoExtraNumberDirectiva)
    .controller('CamposExtraTextCtrl', CamposExtraTextCtrl)
    .directive('campoExtraText', CampoExtraTextDirectiva)
    .controller('CamposExtraListCtrl', CamposExtraListCtrl)
    .directive('campoExtraList', campoExtraListDirectiva)
    .controller('CamposExtraListApiCtrl', CamposExtraListApiCtrl)
    .directive('campoExtraListApi', campoExtraListApiDirectiva)
    .controller('CamposExtraFirmaCtrl', CamposExtraFirmaCtrl)
    .directive('campoExtraFirma', CamposExtraFirmaDirectiva)
;

export default CamposExtraModule;